import { createFileRoute } from "@tanstack/react-router";
import { UniversityAtlas } from "@/components/University";

function RouteComponent() {
  return <UniversityAtlas />;
}

export const Route = createFileRoute("/_authenticated/atlas/")({
  component: RouteComponent,
  staticData: { page: "university" },
});
